/**
 * Resolve the active gurudwara id on mygurudwara / portal booking screens
 * when the route is global (/gurudwara/sarai/bookings) without :id in the path.
 */

const GURUDWARA_ADMIN_PORTAL_KEYS = ['mygurudwara', 'gurudwara']

export function normalizePortalSubdomain(subdomain) {
  return String(subdomain || '')
    .toLowerCase()
    .replace(/^(dev|stage|prod|test)-?/, '')
}

export function getPortalSubdomainFromHostname(hostname = window.location.hostname) {
  const host = String(hostname || '').toLowerCase()
  const parts = host.split('.')
  if (parts.length <= 2) {
    return normalizePortalSubdomain(parts[0])
  }
  const extracted = parts.slice(0, parts.length - 2).join('.')
  return normalizePortalSubdomain(extracted)
}

/** True on mygurudwara / gurudwara admin portals (not main super-admin host). */
export function isGurudwaraAdminPortal(hostname = window.location.hostname) {
  const host = String(hostname || '').toLowerCase()
  if (host.includes('mygurudwara')) return true
  const key = getPortalSubdomainFromHostname(host)
  return GURUDWARA_ADMIN_PORTAL_KEYS.includes(key)
}

/** @deprecated use isGurudwaraAdminPortal */
export function isMyGurudwaraPortal() {
  return isGurudwaraAdminPortal()
}

export function resolveGurudwaraIdFromContext(vm) {
  if (!vm) return null
  const route = vm.$route && vm.$route.params
  const fromRoute = vm.overrideGurudwaraId || (route && (route.gurudwaraId || route.id))
  if (fromRoute) return String(fromRoute)

  const store = vm.$store
  if (store && store.state.adminNotifications && store.state.adminNotifications.defaultGurudwaraId) {
    return String(store.state.adminNotifications.defaultGurudwaraId)
  }

  const user = store && store.state.auth && store.state.auth.userInfo
  if (user && user.gurudwara) {
    return String(user.gurudwara._id || user.gurudwara)
  }

  return null
}
